var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#fff"},[React.createElement("path",{"d":"m4.76838 6.65625h-4.502755v13.80775h4.502755z","key":0}),React.createElement("path",{"d":"m2.54837 0c-1.53924 0-2.54837 1.03184-2.54837 2.38592 0 1.32478.977195 2.38592 2.4877 2.38592h.02874c1.57117 0 2.54837-1.06114 2.54837-2.38592-.02874-1.35408-.9772-2.38592-2.51644-2.38592z","key":1}),React.createElement("path",{"d":"m15.8204 6.33057c-2.3887 0-3.4585 1.3378-4.0589 2.2785v-1.95626h-4.50271c.06067 1.29549 0 13.80769 0 13.80769h4.50271v-7.7078c0-.4134.0288-.8268.1469-1.1197.3258-.8235 1.0667-1.67961 2.3089-1.67961 1.6287 0 2.2801 1.26621 2.2801 3.12151v7.3889h4.5028v-7.9194c.0032-4.2413-2.2195-6.21383-5.1798-6.21383z","key":2})]));
}

Linkedin.defaultProps = {"fill":"none","viewBox":"0 0 21 21"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
